module.exports = __webpack_public_path__ + "media/images/pic/saska/test_lessons-6794b5d0fe137be5d6ac2636f42b6a02.png";